/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Cnpj_RequiredInputs */

const en_clients_validation_cnpj_required = /** @type {(inputs: Clients_Validation_Cnpj_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNPJ is required.`)
};

const pt_br2_clients_validation_cnpj_required = /** @type {(inputs: Clients_Validation_Cnpj_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNPJ é obrigatório.`)
};

/**
* | output |
* | --- |
* | "CNPJ is required." |
*
* @param {Clients_Validation_Cnpj_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_cnpj_required = /** @type {((inputs?: Clients_Validation_Cnpj_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Cnpj_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_cnpj_required(inputs)
	return pt_br2_clients_validation_cnpj_required(inputs)
});